import React, { useRef, useState } from "react";
import { Button } from "@material-ui/core";

const TOUCH_COOLDOWN_MS = 700;

const ButtonAsync = ({children, ...props}) => {
    const [executing, setExecuting] = useState(false);
    const executingRef = useRef(false);
    const cooldownTimerRef = useRef(null);
    
    const {
        disabled,
        onClick,
        ...otherProps
    } = props;

    const onRealClick = async (event) => {
        if (executingRef.current) return;
        executingRef.current = true;
        setExecuting(true);
        if (cooldownTimerRef.current) {
            clearTimeout(cooldownTimerRef.current);
            cooldownTimerRef.current = null;
        }
        try {
            await onClick(event);
        } finally {
            // Keep disabled through cooldown to absorb double-taps / ghost clicks on touch devices
            cooldownTimerRef.current = setTimeout(() => {
                executingRef.current = false;
                setExecuting(false);
                cooldownTimerRef.current = null;
            }, TOUCH_COOLDOWN_MS);
        }
    };

    return (
    <Button
        onClick={onRealClick}
        disabled={executing || disabled}
        {...otherProps}
      >
        {children}
      </Button>
    );
};

export default ButtonAsync;
